import React from 'react';
import { MailIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-plum text-white" data-id="element-53" data-mp="3gezfnanhw34b">
      <div className="mx-auto max-w-4xl px-5 py-12 text-center" style={{
      paddingTop: "25px"
    }} data-id="element-54" data-mp="3ggtwodvnbb34">
        <p className="font-display text-xl font-black text-white" data-id="element-55" data-mp="32pp764lzrz6i">
          SIGMA SMART<span className="align-super text-xs" data-id="element-56" data-mp="36q92r3qx2uqj">™</span> — LES 100 PRÉCÉDENTS JURIDIQUES AI<span className="align-super text-xs" data-id="element-57" data-mp="3uesczotj1hl9">™</span>
        </p>

        <p className="mt-4 font-display text-base font-semibold italic text-grape-soft" data-id="element-58" data-mp="38quwwb59nq4">
          🏥 « Votre dernière session de rédaction tard le soir se termine aujourd'hui. »
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-white/75" data-id="element-59" data-mp="3lgon6gbidynn">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-white" data-id="element-60" data-mp="29zgl41oc4umn">
            <MailIcon className="h-4 w-4 text-blush" data-id="element-61" data-mp="2ezurlfaafwik" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-white" data-id="element-62" data-mp="3la27uq37evt4">
            <InstagramIcon className="h-4 w-4 text-blush" data-id="element-63" data-mp="3gctpopi22rrv" /> @sigmasmart.french
          </a>
        </div>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-white/55" data-id="element-64" data-mp="3v5dhwv3o3euj">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-65" data-mp="830jvkr3s91j">
            Conditions Générales
          </a>
          <span data-id="element-66" data-mp="32w1fp6mx48o">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-67" data-mp="33e5h7zjgmr5">
            Politique de Confidentialité
          </a>
          <span data-id="element-68" data-mp="cu0geowb8p3i">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-69" data-mp="cth01cmb68rl">
            Support
          </a>
        </div>

        <p className="mt-8 text-xs leading-relaxed text-white/45" data-id="element-70" data-mp="qtrsgk39nvev">
          © 2026 SIGMA SMART™ — Tous droits réservés.
        </p>
      </div>
    </footer>;
}